import React from 'react';
import { NextPageContext } from 'next';

import { TeamsSection } from '../../components';
import { useStore } from '../../hooks';
import NotFoundPage from '../404';

import Page from '../[...all]';

import styles from './index.module.scss';

interface Props {
  uri: string;
}

const Teams = ({ uri }: Props) => {
  const { site } = useStore('globals');

  if (site !== 'careers') {
    return <NotFoundPage />;
  }

  return (
    <div className={styles.teams}>
      <Page uri={uri} />
      <TeamsSection />
    </div>
  );
};

Teams.getInitialProps = ({ req }: NextPageContext) => ({
  uri: req?.url?.replace(/^\//, '').replace(/\?.*$/, '') || '404',
});

export default Teams;
